<template>
  <component :is="isShowAdminHeader ? AdminHeaderComponent : 'div'" />
  <component :is="SpinnerOverlayComponent" />
  <main v-if="!isShowAdminHeader" class="main">
    <RouterView />
  </main>
</template>

<script setup>
import { computed, defineAsyncComponent } from "vue";
import { useRoute } from "vue-router";
import { useAdLoader } from "@/utils/ads";

const route = useRoute();
const adminRoutes = ["/admin", "/admin/*", "/login", "/dashboard"];

// Use the isAdminRoute from your ads utility for consistency
// eslint-disable-next-line
const { loadAdScript } = useAdLoader(adminRoutes);
const isShowAdminHeader = computed(() => route.path.startsWith("/admin"));
// Initial ad load
//loadAdScript();

// Lazy load components
const AdminHeaderComponent = defineAsyncComponent(() =>
  import("@/components/AdminHeader.vue")
);
const SpinnerOverlayComponent = defineAsyncComponent(() =>
  import("@/components/SpinnerOverlay.vue")
);
</script>

<style scoped></style>
